import { render } from "./ResizingTextArea.vue?vue&type=template&id=b755f75c&scoped=true"
import script from "./ResizingTextArea.vue?vue&type=script&lang=js"
export * from "./ResizingTextArea.vue?vue&type=script&lang=js"

import "./ResizingTextArea.vue?vue&type=style&index=0&id=b755f75c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b755f75c"]])

export default __exports__